var map = {
	"./AMERICAN_EXPRESS.png": 3583,
	"./CARD.png": 5510,
	"./DISCOVER.png": 689,
	"./JCB.png": 8027,
	"./MASTERCARD.png": 1532,
	"./VISA.png": 3915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8681;